

    import { ref } from 'vue';
    import moment from 'moment';
    import BookRepository from "@/services/BookRepository";
    import BookResult from "@/models/bookresult.models";
    import {Team} from "@/models/team.models";
    import TeamRepository from "@/services/TeamRepository";
    import {useToast} from "primevue/usetoast";
    import NameBook from "@/models/namebook.models";
    import router from "@/router";
    import {useStore} from "vuex";
    import {HenTaiKham} from "@/models/henTaiKham";

    export default {
        props: {
            id: Number,
        },
        setup(){
            const phoneNumber = ref("");
            const taiKham = ref([] as HenTaiKham[]);
            const teams = ref({} as Team[]);
            const toast = useToast();
            const name = ref("");
            const listName = ref([] as NameBook[]);
            const date1 = ref(new Date());
            const invalid = ref(true);
            const store = useStore();

            if(store.state.token == ""){
                router.push({
                    name: 'home'
                });
            }

            TeamRepository.getTeams()
                .then((response) => {
                    teams.value = response.data;
                })
                .catch();

            const clear = () => { phoneNumber.value = ""};

            const selectCalendar = () => {
              if ((date1.value[0] != null) && (date1.value[1] != null)) {
                BookRepository.getListTaiKham(date1.value[0] / 1000, date1.value[1] / 1000)
                    .then(response => {
                      taiKham.value = response.data;
                    })
                    .catch(err => {
                      toast.add({
                        severity: 'error',
                        summary: 'Lỗi',
                        detail: "Không tìm thấy dữ liệu trong thời gian trên.",
                        life: 2000
                      });
                    })
                    .finally(() => {
                    });
              }
              ;
            }
            const clearCalendar = () => {
              taiKham.value = [];
            };
          const formatDateTime = (date) => {
            if((date == null)||(date == ''))
            {
              return "chưa có thông tin"
            }
            else
              return moment(String(date)).format('DD/MM/YYYY');
          };

            return {
                phoneNumber,
                clear,
                name,
                listName,
                selectCalendar,
                date1,
                invalid,
                clearCalendar,
              formatDateTime,
              taiKham,
            }
        }
    }

